<template>
  <div class="panel-body">
    <div class="content" ref="promotionList" style="position: relative">
      <div class="row m-t-md m-b-xs" style="position: relative">
        <div class="idea-row">
          <button
            class="btn btn-info w-120"
            :disabled="checkDisabledAddButton"
            @click="openModal"
            ref="addPromotionBtn"
            style="position: relative"
          >
            新規登録
          </button>
          <template v-if="hasRecommended > 0">
            <span class="idea-ribbon">{{ hasRecommended }}件</span>
            <span class="idea-banner">
              <img
                src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png"
                alt="SaleMon Agent"
                class="idea-agent-icon"
              />
              登録を推奨する商品があります！
            </span>
          </template>
        </div>
      </div>
      <p>新規登録ボタンから広告運用する商品を登録することができます。</p>
      <p class="text-red">商品名・在庫は最新でない場合がございます。</p>
      <div class="alert alert-danger text-center p-xxs m-b-xs" v-if="isPromotion">
        <h5 class="m-b-none"><router-link :to="{path: '/promotion/top'}">こちら</router-link>から広告の運用の設定を「申し込み」にしてください。</h5>
      </div>
      <base-table
        :url="'PromotionProduct/list'"
        :extraUrl="['Product/get-image-name']"
        :extraUrlMode="true"
        :columns="columns"
        :searchValue="keyword"
        :isSearchable="true"
        :isShowBtnBulkDelete="true"
        :checkedItems="checkedItems"
        @countData="countData = $event"
        @checkBoxAll="toggleCheckAll"
        @keyword="onHandleSearch"
        @confirmDelete="showAlert"
        ref="promotionTable"
      >
        <template slot="deleteCheckBox" slot-scope="props">
          <input type="checkbox" :value="props.rowData.asin" v-model="checkedItems" @change="refreshCheckAll">
        </template>
        <template slot="image" slot-scope="props">
          <loading-block :value="props.rowData.image" type="image">
            <img :src="prepareImgSrc(props.rowData.image)" class="product-img"/>
          </loading-block>
        </template>
        <template slot="productName" slot-scope="props">
          <loading-block :value="props.rowData.productName" type="string">
            <a class="text--underline" :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin" target="_blank">
              {{props.rowData.productName}}
            </a>
          </loading-block>
        </template>
      </base-table>
    </div>
    <promotion-add
      v-if="isShowModal"
      ref="addPromotionModal"
      :isShow="isShowModal"
      :isLoadingButton="loadingButton"
      @isAddPromotion="handleAddPromotion"
      @refreshPromotions="refreshPromotions"
      @close="closeModal"
      @checkAvailableItem="checkAvailableItem"
    ></promotion-add>
    <modal-delete-alert v-if="isShowAlert" @close="closeAlert" @confirm="deletePromotion" :message="alertMessage"></modal-delete-alert>
  </div>
</template>
<script>
import PromotionAdd from '@/view/promotion/PromotionAdd'
import BaseTable from '@/components/BaseTableClient'
import LoadingBlock from '@/components/LoadingBlock'
import Util from '@/common/utility'
import PromotionService from '@/services/promotionservice'
import ModalDeleteAlert from '@/components/ModalDeleteAlert'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },

  components: {
    PromotionAdd,
    BaseTable,
    ModalDeleteAlert,
    LoadingBlock
  },

  data () {
    return {
      showWarning: false,
      err: null,
      countData: null,
      isShowAlert: false,
      isShowModal: false,
      isRefresh: false,
      isAddPromotion: false,
      deleteInfo: null,
      alertMessage: null,
      loadingButton: false,
      loaderButton: null,
      loader: null,
      reload: false,
      hasAvailableItem: false,
      search: null,
      keyword: null,
      originalData: [],
      isPromotion: false,
      checkAll: false,
      checkedItems: [],
      columns: [
        {
          title: '',
          name: 'deleteCheckBox',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-40',
          sortable: false,
          checkable: true
        },
        {
          title: '画像',
          sortable: false,
          name: 'image',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-150'
        },
        {
          title: 'ASIN',
          name: 'asin',
          cellClass: 'text-center',
          headerClass: 'w-150'
        },
        {
          title: '商品名',
          name: 'productName',
          customCell: true,
          cellClass: 'text-left',
          headerClass: 'product-name'
        }
      ]
    }
  },

  computed: {
    checkDisabledAddButton () {
      return this.changePromotion === '0'
    },

    checkDisabledDeleteButton () {
      return this.checkedItems.length === 0
    },

    changePromotion () {
      return this.$store.getters.getUser.promotionFlg
    },

    hasRecommended () {
      return this.$store.getters.getUser.countSalemonRecommend
    }
  },

  created () {
    this.init()
    this.$store.watch(
      (state, getters) => getters.getUser.promotionFlg,
      (newValue, oldValue) => {
        if (newValue === '0') {
          this.isPromotion = true
        } else {
          this.isPromotion = false
        }
      }
    )
  },

  methods: {
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },

    openModal () {
      this.isShowModal = true
      this.isAddPromotion = false
      let logParams = {
        name: eventCode.promotion.request_tab.click_register_new_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },

    closeModal () {
      if (this.isAddPromotion) {
        this.refreshPromotions()
      }
      $('#promotionadd').modal('hide')
      this.isShowModal = false
    },

    checkSellerState () {
      const promotionStatus = this.$store.getters.getUser.promotionFlg
      if (promotionStatus === '0') {
        this.isPromotion = true
        return this.isPromotion
      }
      return this.isPromotion
    },

    isEmptyObj (obj) {
      return Util.isEmptyObj(obj)
    },

    formatAmount (value) {
      return (value === null || typeof value === 'undefined') ? '' : `¥${Util.formatMoney(value)}`
    },

    deletePromotion () {
      let self = this
      const items = self.checkedItems
      let payload = {
        record: {
          asins: items
        }
      }

      let logParams = {
        name: eventCode.promotion.request_tab.click_delete_all_button,
        properties: {
          asins: items
        }
      }
      EventService.postTrackLog(logParams)

      this.checkedItems = []
      self.loader = this.$loading.show()
      this.closeAlert()
      PromotionService.deletePromotionProduct(payload)
        .then(response => {
          self.reRenderTable()
          if (self.$refs.addPromotionModal) {
            items.forEach(function (asin) {
              const addPromotion = self.originalData.find(item => item.asin === asin)
              self.$refs.addPromotionModal.$refs.promotionTable.handleData(addPromotion, 'add')
            })
            self.$refs.addPromotionModal.$refs.promotionTable.reload()
          }
          this.checkAll = false
          this.checkedItems = []
          self.loader && self.loader.hide()
        })
        .catch(err => {
          self.loadingButton = false
          self.loader && self.loader.hide()
          self.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },

    reRenderTable () {
      this.$refs.promotionTable.reload()
    },

    showAlert () {
      const originalData = this.$refs.promotionTable.originalData
      this.originalData = [...originalData]
      this.isShowAlert = true
    },

    closeAlert () {
      this.isShowAlert = false
      $('#delete-alert').modal('hide')
    },

    init () {
      let self = this
      self.loader = self.$loading.show()
      self.checkSellerState()
    },

    refreshPromotions () {
      this.isRefresh = true
      this.reRenderTable()
    },

    handleAddPromotion () {
      this.isAddPromotion = true
      this.search = null
      this.keyword = this.search
    },

    checkAvailableItem (countData, keyword) {
      if (!this.hasAvailableItem && ((countData && countData > 0) || keyword)) {
        this.hasAvailableItem = true
      }
      if (this.checkSellerState()) {
        this.hasAvailableItem = false
      }
    },

    sortExpectedAmount (data, order) {
      if (!order) {
        return [...data]
      } else if (order === 'desc') {
        return [...data].sort((before, after) => before.offerPrice - after.offerPrice)
      }
      return [...data].sort((before, after) => after.offerPrice - before.offerPrice)
    },

    onHandleSearch () {
      this.checkAll = false
      this.checkedItems = []
      this.keyword = this.search
      let logParams = {
        name: eventCode.promotion.request_tab.click_filter_button,
        properties: {
          keyword: this.search
        }
      }
      EventService.postTrackLog(logParams)
    },

    toggleCheckAll () {
      const items = this.$refs.promotionTable.defaultData
      this.checkAll = !this.checkAll
      this.checkedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          _self.checkedItems.push(item.asin)
        })
      }
    },

    refreshCheckAll () {
      const items = this.$refs.promotionTable.defaultData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    }
  },

  watch: {
    isShowModal (newVal) {
      if (!newVal && this.isRefresh) {
        this.loader = this.$loading.show()
      }
    },
    changePromotion () {
      this.$nextTick(() => {
      })
    }
  },

  mounted () {
    let self = this
    $('#promotionadd').modal('hide')
    $('.modal-backdrop').remove()
    this.$events.listen('done', (url) => {
      if (url === 'PromotionProduct/list') {
        this.isRefresh = false
        self.loader && self.loader.hide()
      }
    })
    if (this.currentTab && this.currentTab === 'promotion-request') {
      let logParams = {
        name: eventCode.promotion.request_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },

  beforeDestroy () {
    this.$events.remove('done')
    $('#promotionadd').modal('hide')
    $('.modal-backdrop').remove()
    this.loader && this.loader.hide()
    this.loaderButton && this.loaderButton.hide()
  }
}
</script>

<style scoped>
.screen-desktop {
  display: block;
}
.screen-mobile {
  display: none;
}
@media (max-width: 320px) {
  .box-btn-search-mobile {
    margin-right: 20px;
  }
}
@media (max-width: 1200px) {
  .screen-desktop {
    display: none;
  }
  .screen-mobile {
    display: block;
  }
  /deep/ .table-wrapper {
    overflow-x: auto;
  }
  /deep/ .table {
    width: auto;
    min-width: max-content;
  }
  /deep/ .table thead tr .product-name {
    max-width: 600px;
    width: 500px;
  }
}

/* btn_4 idea4 — 新規登録 button row */
.idea-row {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding-top: 18px;
}
.idea-ribbon {
  position: absolute;
  top: -1px;
  right: -6px;
  z-index: 2;
  background: #2f7d4f;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px 4px 12px;
  border-radius: 3px 3px 3px 0;
  white-space: nowrap;
}
.idea-ribbon::after {
  content: '';
  position: absolute;
  left: 0;
  top: 100%;
  border-left: 5px solid transparent;
  border-top: 5px solid #1d5330;
}
.idea-banner {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f4fbe8;
  color: #2f6b3a;
  border: 1px solid #cdebb0;
  border-radius: 6px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.idea-agent-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  border-radius: 5px;
  flex-shrink: 0;
  animation: fuwafuwa 3s ease-in-out infinite alternate;
}

@keyframes fuwafuwa {
  0% {
    transform:translate(0, 0) rotate(-5deg);
  }
  50% {
    transform:translate(0, -5px) rotate(0deg);
  }
  100% {
    transform:translate(0, 0) rotate(5deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/promotion/PromotionRequest.vue